import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

const store = window.sessionStorage;
export const tokens = {
  get access() { return store.getItem("mc_at"); },
  get refresh() { return store.getItem("mc_rt"); },
  set(a, r) { store.setItem("mc_at", a); if (r) store.setItem("mc_rt", r); },
  clear() { store.removeItem("mc_at"); store.removeItem("mc_rt"); },
};

api.interceptors.request.use((cfg) => {
  if (tokens.access) cfg.headers.Authorization = `Bearer ${tokens.access}`;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use((r) => r, async (err) => {
  const orig = err.config || {};
  const skip = orig.url?.includes("/auth/login") || orig.url?.includes("/auth/refresh");
  if (err.response?.status === 401 && tokens.refresh && !orig._retry && !skip) {
    orig._retry = true;
    refreshing = refreshing || axios.post(`${API}/auth/refresh`, { refresh_token: tokens.refresh });
    try {
      const { data } = await refreshing;
      tokens.set(data.access_token);
      return api(orig);
    } catch {
      tokens.clear();
      window.dispatchEvent(new Event("mc-logout"));
    } finally {
      refreshing = null;
    }
  }
  return Promise.reject(err);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.response ? "Something went wrong. Please try again." : "Connection problem. Please check your internet and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace("Value error, ", "") : "Invalid input")).join(" ");
  return String(d);
}

export async function download(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-PH", { year: "numeric", month: "short", day: "numeric" }) : "—");
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("en-PH", { dateStyle: "medium", timeStyle: "short" }) : "—");
